module.exports = __webpack_public_path__ + "static/media/banner-ezadmin.0cee8408.jpg";